import React from 'react';
import ListItem from '../../../../elements/DEPRECATED_ListItem';

const EventLocation = props => {
    const {event} = props,
        {location_name, location_address, location_city} = event;

    if (!(location_name || location_address || location_city)) return null;

    return (
        <ListItem tagName="div" icon="img/globe_small.png" iconColor="#a9a9a9">
            <p
                className="text main text-upper"
                style={{
                    color: 'black',
                }}>
                <b>{location_name}</b>
            </p>
            {(location_address || location_city) && <p className="text text-upper">{[location_address, location_city].filter(i => i).join(', ')}</p>}
        </ListItem>
    );
};

export default EventLocation;
